import { defineComponent as _defineComponent } from 'vue'
import BCXSuggestionBox from '@/components/molecules/BCXSuggestionBox.vue';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSelector',
  props: {
  value: {
    type: String,
    default: ''
  },
  showAllWhenEmpty: Boolean,
  projectList: {
    type: Array as PropType<any[]>,
    default: () => []
  },
  placeholder: {
    type: String,
    default: ''
  },
  clearable: {
    type: Boolean,
    default: false
  },
  filterable: {
    type: Boolean,
    default: true
  },
  disabled: Boolean
},
  emits: ['select'],
  setup(__props, { emit }) {

const props = __props;





const { getFormattedTimeByAge } = useFormattedDateTime();
const projectName = useVModel(props);

const onClickItem = async (item: any, close: CallableFunction) => {
  emit('select', item);
  close();
};

return { __sfc: true,props, emit, getFormattedTimeByAge, projectName, onClickItem, BCXSuggestionBox }
}

})